module.exports = __webpack_public_path__ + "assets/img/driver-btn-3d3eb94c.png";